import { gql } from 'apollo-angular';

export const pageInfoFragment = gql`
fragment pageInfo on PageInfo  {
  startCursor
  endCursor
  hasNextPage
  hasPreviousPage
  __typename
}
`;
